(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-annc]').forEach((bar) => {
    const slides = [...bar.querySelectorAll('.ax-annc__slide')];
    if (slides.length <= 1) return;

    const autorotate = bar.dataset.autorotate === 'true';
    const interval = parseInt(bar.dataset.interval, 10) || 5000;
    let i = 0;
    let timer = null;

    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-on', k === i));
    };
    const reset = () => {
      clearInterval(timer);
      if (autorotate) timer = setInterval(() => go(i + 1), interval);
    };

    const next = bar.querySelector('[data-annc-next]');
    const prev = bar.querySelector('[data-annc-prev]');
    if (next) next.addEventListener('click', () => { go(i + 1); reset(); });
    if (prev) prev.addEventListener('click', () => { go(i - 1); reset(); });
    bar.addEventListener('mouseenter', () => clearInterval(timer));
    bar.addEventListener('mouseleave', reset);
    reset();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-cart-section]');
    if (!root) return;

    const sectionId = root.dataset.sectionId;
    const cartUrl = root.dataset.cartUrl || '/cart';

    function setBadge(count) {
      const link = document.querySelector('a[href$="/cart"]') || document.querySelector('.ax-icon-btn');
      if (!link) return;
      let badge = link.querySelector('.ax-icon-btn__badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'ax-icon-btn__badge';
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    }

    async function refresh() {
      const res = await fetch(`${cartUrl}?section_id=${sectionId}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-cart-section] .ax-cart__wrap');
      const current = root.querySelector('.ax-cart__wrap');
      if (next && current) current.innerHTML = next.innerHTML;
    }

    async function changeLine(line, quantity) {
      root.setAttribute('data-loading', '');
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity }),
        });
        const cart = await res.json();
        setBadge(cart.item_count);
        await refresh();
      } finally {
        root.removeAttribute('data-loading');
      }
    }

    function lineOf(el) {
      const row = el.closest('[data-cart-row]');
      return row ? parseInt(row.dataset.line, 10) : null;
    }

    root.addEventListener('click', (evt) => {
      const remove = evt.target.closest('[data-cart-remove]');
      if (remove) {
        evt.preventDefault();
        const line = lineOf(remove);
        if (line) changeLine(line, 0);
        return;
      }
      const up = evt.target.closest('[data-qty-up]');
      const down = evt.target.closest('[data-qty-down]');
      if (up || down) {
        const input = (up || down).closest('.ax-cart__stepper').querySelector('[data-qty-input]');
        let q = parseInt(input.value, 10) || 0;
        q = up ? q + 1 : Math.max(0, q - 1);
        input.value = q;
        const line = lineOf(input);
        if (line) changeLine(line, q);
      }
    });

    root.addEventListener('change', (evt) => {
      const input = evt.target.closest('[data-qty-input]');
      if (!input) return;
      const line = lineOf(input);
      const q = Math.max(0, parseInt(input.value, 10) || 0);
      if (line) changeLine(line, q);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    const form = document.getElementById('FacetFilterForm');
    if (!form) return;

    const submit = () => form.submit();
    const isDrawer = () => window.matchMedia('(max-width: 900px)').matches;

    // Inputs inside the form (checkboxes, price) bubble their change to the form.
    // On mobile the facets live in a drawer: batch changes and apply on demand
    // (via "Voir les résultats") instead of reloading on every tap.
    form.addEventListener('change', (e) => {
      if (isDrawer() && e.target.closest('[data-facets-drawer]')) return;
      submit();
    });

    // The sort <select> is associated via the `form` attribute but lives outside
    // the form's DOM subtree, so its change must be wired up explicitly. It is not
    // in the drawer, so it always submits immediately.
    document.querySelectorAll('[form="FacetFilterForm"]').forEach((el) => {
      if (el.closest('#FacetFilterForm')) return;
      el.addEventListener('change', submit);
    });
  })();

  /* ── Mobile / tablet facets drawer ── */
  (function () {
    const drawer = document.querySelector('[data-facets-drawer]');
    const overlay = document.querySelector('[data-facets-overlay]');
    if (!drawer || !overlay) return;
    const openBtn = document.querySelector('[data-facets-open]');

    const open = () => {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    };

    if (openBtn) openBtn.addEventListener('click', open);
    overlay.addEventListener('click', close);
    document.querySelectorAll('[data-facets-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

    const applyBtn = drawer.querySelector('[data-facets-apply]');
    if (applyBtn) applyBtn.addEventListener('click', () => {
      const f = document.getElementById('FacetFilterForm');
      if (f) f.submit();
    });
  })();

  // Persist which facet panels are open across the filter reloads.
  (function () {
    const KEY = 'ax-facets-state';
    const read = () => {
      try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
    };
    const write = (s) => {
      try { sessionStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
    };

    document.querySelectorAll('details.ax-facet[data-facet-key]').forEach((d) => {
      const stateKey = 'facet:' + d.dataset.facetKey;
      const saved = read();
      if (stateKey in saved) d.open = saved[stateKey];
      d.addEventListener('toggle', () => {
        const s = read();
        s[stateKey] = d.open;
        write(s);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    /* ── Desktop dropdowns / mega-menus ── */
    const items = document.querySelectorAll('[data-nav-item]');
    const closeAll = (except) => {
      items.forEach((it) => {
        if (it === except) return;
        it.classList.remove('is-open');
        const t = it.querySelector('[data-nav-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    };
    const openItem = (it) => {
      closeAll(it);
      it.classList.add('is-open');
      const t = it.querySelector('[data-nav-trigger]');
      if (t) t.setAttribute('aria-expanded', 'true');
    };
    const closeItem = (it) => {
      it.classList.remove('is-open');
      const t = it.querySelector('[data-nav-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    };

    items.forEach((it) => {
      const trigger = it.querySelector('[data-nav-trigger]');
      it.addEventListener('mouseenter', () => openItem(it));
      it.addEventListener('mouseleave', () => {
        if (!it.contains(document.activeElement)) closeItem(it);
      });
      if (trigger) {
        trigger.addEventListener('click', () => {
          it.classList.contains('is-open') ? closeItem(it) : openItem(it);
        });
      }
      it.addEventListener('focusout', (e) => {
        if (!it.contains(e.relatedTarget)) closeItem(it);
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const open = document.querySelector('[data-nav-item].is-open');
      if (!open) return;
      const t = open.querySelector('[data-nav-trigger]');
      closeItem(open);
      if (t) t.focus();
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-nav-item]')) closeAll(null);
    });

    /* ── Mobile off-canvas drawer ── */
    const drawer = document.querySelector('[data-drawer]');
    const hamburger = document.querySelector('[data-drawer-open]');
    if (drawer && hamburger) {
      const panel = drawer.querySelector('.ax-drawer__panel');
      let lastFocus = null;

      const focusable = () => panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');

      const openDrawer = () => {
        lastFocus = document.activeElement;
        drawer.hidden = false;
        requestAnimationFrame(() => drawer.classList.add('is-open'));
        hamburger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        const close = drawer.querySelector('.ax-drawer__close');
        if (close) close.focus();
      };
      const closeDrawer = () => {
        drawer.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        const onEnd = () => {
          drawer.hidden = true;
          panel.removeEventListener('transitionend', onEnd);
        };
        panel.addEventListener('transitionend', onEnd);
        if (lastFocus) lastFocus.focus();
      };

      hamburger.addEventListener('click', openDrawer);
      drawer.querySelectorAll('[data-drawer-close]').forEach((b) => b.addEventListener('click', closeDrawer));

      drawer.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          closeDrawer();
          return;
        }
        if (e.key !== 'Tab') return;
        const f = Array.from(focusable());
        if (!f.length) return;
        const first = f[0];
        const last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      /* Accordion sub-menus inside the drawer */
      drawer.querySelectorAll('.ax-drawer__toggle').forEach((btn) => {
        btn.addEventListener('click', () => {
          const row = btn.closest('.ax-drawer__row');
          const sub = row ? row.nextElementSibling : null;
          if (!sub) return;
          const willOpen = sub.hidden;
          sub.hidden = !willOpen;
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
      });
    }
  })();

  /* ── Predictive search ── */
  (function () {
    document.querySelectorAll('[data-predictive-search]').forEach((root) => {
      const input = root.querySelector('[data-predictive-input]');
      const panel = root.querySelector('[data-predictive-results]');
      if (!input || !panel) return;

      let controller;
      let debounce;

      const close = () => {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      };
      const showIfContent = () => {
        if (panel.innerHTML.trim()) {
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        }
      };

      const run = (q) => {
        if (q.length < 2) { panel.innerHTML = ''; close(); return; }
        if (controller) controller.abort();
        controller = new AbortController();
        const url = '/search/suggest?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search&resources[type]=product,query&resources[limit]=6';
        fetch(url, { signal: controller.signal })
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const content = doc.querySelector('.ax-psearch');
            panel.innerHTML = content ? content.outerHTML : '';
            showIfContent();
          })
          .catch(() => {});
      };

      input.addEventListener('input', () => {
        clearTimeout(debounce);
        debounce = setTimeout(() => run(input.value.trim()), 200);
      });
      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2) showIfContent();
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { close(); return; }
        const options = Array.from(panel.querySelectorAll('[role="option"]'));
        if (!options.length) return;
        let idx = options.findIndex((o) => o.classList.contains('is-active'));
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          idx = idx + 1 >= options.length ? 0 : idx + 1;
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          idx = idx <= 0 ? options.length - 1 : idx - 1;
        } else if (e.key === 'Enter') {
          if (idx >= 0) { e.preventDefault(); options[idx].click(); }
          return;
        } else {
          return;
        }
        options.forEach((o) => o.classList.remove('is-active'));
        const active = options[idx];
        active.classList.add('is-active');
        active.scrollIntoView({ block: 'nearest' });
        if (active.id) input.setAttribute('aria-activedescendant', active.id);
      });

      document.addEventListener('click', (e) => {
        if (!root.contains(e.target)) close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero]').forEach((hero) => {
    const vp = hero.querySelector('[data-hero-vp]');
    const slides = [...vp.querySelectorAll('.ax-hero__slide')];
    if (slides.length <= 1) return;

    const dotsWrap = hero.querySelector('[data-hero-dots]');
    const cur = hero.querySelector('[data-hero-cur]');
    const autoplay = hero.dataset.autoplay === 'true';
    const interval = parseInt(hero.dataset.interval, 10) || 6000;
    let i = 0;
    let timer = null;

    const dots = slides.map((_, k) => {
      const b = document.createElement('button');
      b.type = 'button';
      if (k === 0) b.classList.add('is-on');
      b.addEventListener('click', () => { go(k); reset(); });
      dotsWrap.appendChild(b);
      return b;
    });

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-on', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      if (cur) cur.textContent = String(i + 1).padStart(2, '0');
    }
    function next() { go(i + 1); }
    function reset() {
      clearInterval(timer);
      if (autoplay) timer = setInterval(next, interval);
    }

    hero.querySelector('[data-hero-next]').addEventListener('click', () => { next(); reset(); });
    hero.querySelector('[data-hero-prev]').addEventListener('click', () => { go(i - 1); reset(); });
    vp.addEventListener('mouseenter', () => clearInterval(timer));
    vp.addEventListener('mouseleave', reset);
    reset();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-agenda"]) return;
  try {
    
  document.querySelectorAll('.ax-ag').forEach((root) => {
    const source = root.querySelector('[data-ag-source]');
    const view = root.querySelector('[data-ag-view]');
    const empty = root.querySelector('[data-ag-empty]');
    if (!source || !view) return;

    const rows = [...source.querySelectorAll('.ax-evrow')];
    let genre = 'all';
    let time = 'upcoming';

    function render() {
      const filtered = rows.filter((r) => {
        const okGenre = genre === 'all' || r.dataset.genre === genre;
        const okTime = time === 'upcoming' ? r.dataset.past === 'false' : r.dataset.past === 'true';
        return okGenre && okTime;
      });
      filtered.sort((a, b) => {
        const d = Number(a.dataset.ts) - Number(b.dataset.ts);
        return time === 'past' ? -d : d;
      });

      view.innerHTML = '';
      let currentMonth = null;

      filtered.forEach((r) => {
        if (r.dataset.month !== currentMonth) {
          currentMonth = r.dataset.month;
          const head = document.createElement('div');
          head.className = 'ax-ag__month';
          head.textContent = r.dataset.monthLabel;
          view.appendChild(head);
        }
        view.appendChild(r);
      });

      empty.hidden = filtered.length > 0;
    }

    root.querySelectorAll('[data-genre]').forEach((btn) => {
      btn.addEventListener('click', () => {
        genre = btn.dataset.genre;
        root.querySelectorAll('[data-genre]').forEach((b) => b.classList.toggle('is-on', b === btn));
        render();
      });
    });
    root.querySelectorAll('[data-time]').forEach((btn) => {
      btn.addEventListener('click', () => {
        time = btn.dataset.time;
        root.querySelectorAll('[data-time]').forEach((b) => b.classList.toggle('is-on', b === btn));
        render();
      });
    });

    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rail-row]').forEach((row) => {
    const ctrls = row.closest('.ax-rail__inner').querySelector('[data-rail-ctrls]');
    if (!ctrls) return;
    const prev = ctrls.querySelector('[data-dir="prev"]');
    const next = ctrls.querySelector('[data-dir="next"]');

    const update = () => {
      const max = row.scrollWidth - row.clientWidth - 1;
      ctrls.hidden = max <= 0;
      if (prev) prev.disabled = row.scrollLeft <= 0;
      if (next) next.disabled = row.scrollLeft >= max;
    };

    ctrls.addEventListener('click', (evt) => {
      const btn = evt.target.closest('button[data-dir]');
      if (!btn) return;
      const delta = btn.dataset.dir === 'next' ? row.clientWidth : -row.clientWidth;
      row.scrollBy({ left: delta, behavior: 'smooth' });
    });

    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('.ax-qty').forEach((qty) => {
    const input = qty.querySelector('input');
    qty.addEventListener('click', (evt) => {
      const btn = evt.target.closest('button[data-qty-step]');
      if (!btn) return;
      const step = parseInt(btn.dataset.qtyStep, 10);
      const next = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + step));
      input.value = next;
    });
  });

  document.querySelectorAll('.ax-buy-form').forEach((form) => {
    const dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const selects = Array.from(form.querySelectorAll('.ax-variants select'))
      .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex);
    if (!selects.length) return;

    const idInput = form.querySelector('input[name="id"]');
    const card = form.querySelector('.ax-buy-card');
    const priceEl = form.querySelector('.ax-buy-card__price');
    const stockEl = form.querySelector('.ax-buy-card__stock');
    const btn = form.querySelector('.ax-btn-cart');
    const label = btn ? btn.querySelector('.ax-btn-cart__label') : null;

    const update = () => {
      const chosen = selects.map((s) => s.value);
      const variant = variants.find((v) =>
        v.options.length === chosen.length && v.options.every((o, i) => o === chosen[i])
      );
      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        priceEl.innerHTML = variant.on_sale
          ? '<s>' + variant.compare_html + '</s> ' + variant.price_html
          : variant.price_html;
      }

      if (stockEl) {
        if (!variant.available) {
          stockEl.innerHTML = '<span class="ax-buy-card__out">' + card.dataset.i18nOut + '</span>';
        } else if (variant.backorder) {
          stockEl.innerHTML = '<span class="ax-buy-card__warn">' + card.dataset.i18nOnorder + '</span>';
        } else {
          stockEl.innerHTML = '<span class="ax-buy-card__ok"><span class="ax-buy-card__dot"></span>' + card.dataset.i18nInstock + '</span>';
        }
      }

      if (btn) {
        btn.disabled = !variant.available;
        btn.classList.toggle('ax-btn-cart--order', !!variant.backorder && variant.available);
        if (label) {
          label.textContent = !variant.available
            ? card.dataset.i18nUnavailable
            : variant.backorder ? card.dataset.i18nOrder : card.dataset.i18nAdd;
        }
      }
    };

    selects.forEach((s) => s.addEventListener('change', update));
  });

  document.querySelectorAll('.ax-product__media').forEach((media) => {
    const stage = media.querySelector('.ax-product__cover-stage img');
    const thumbs = media.querySelectorAll('.ax-product__thumb');
    if (!stage || thumbs.length === 0) return;
    media.addEventListener('click', (evt) => {
      const thumb = evt.target.closest('.ax-product__thumb');
      if (!thumb || !thumb.dataset.full) return;
      stage.removeAttribute('srcset');
      stage.src = thumb.dataset.full;
      if (thumb.dataset.alt) stage.alt = thumb.dataset.alt;
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  function axRailCarousel(row, ctrls) {
    if (!ctrls) return;
    const prev = ctrls.querySelector('[data-dir="prev"]');
    const next = ctrls.querySelector('[data-dir="next"]');
    const update = () => {
      const max = row.scrollWidth - row.clientWidth - 1;
      ctrls.hidden = max <= 0;
      if (prev) prev.disabled = row.scrollLeft <= 0;
      if (next) next.disabled = row.scrollLeft >= max;
    };
    ctrls.addEventListener('click', (evt) => {
      const btn = evt.target.closest('button[data-dir]');
      if (!btn) return;
      const delta = btn.dataset.dir === 'next' ? row.clientWidth : -row.clientWidth;
      row.scrollBy({ left: delta, behavior: 'smooth' });
    });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function axInitRail(root) {
    const row = root.querySelector('[data-related-row]');
    const ctrls = root.querySelector('[data-related-ctrls]');
    const empty = root.querySelector('[data-related-empty]');
    const loading = root.querySelector('[data-related-loading]');
    const cfgEl = root.querySelector('[data-rail-filters]');

    const stopLoading = () => { if (loading) loading.remove(); };
    const showEmpty = () => { stopLoading(); if (row) row.hidden = true; if (ctrls) ctrls.hidden = true; if (empty) empty.hidden = false; };

    let filters = [];
    try { filters = JSON.parse(cfgEl.textContent); } catch (e) { filters = []; }
    if (!filters.length) { showEmpty(); return; }

    const params = new URLSearchParams();
    params.set('section_id', 'collection-rail-cards');
    params.set('sort_by', root.dataset.sort || 'created-descending');
    filters.forEach((f) => { if (f && f.k && f.v) params.append(f.k, f.v); });

    fetch('/collections/all?' + params.toString())
      .then((res) => { if (!res.ok) throw new Error('rail fetch failed'); return res.text(); })
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const current = (root.dataset.currentUrl || '').split('?')[0];
        const limit = parseInt(root.dataset.limit, 10) || 12;
        let cards = Array.from(parsed.querySelectorAll('.ax-card'));
        cards = cards.filter((c) => {
          const link = c.querySelector('.ax-card__frame, a[href*="/products/"]');
          const href = link ? (link.getAttribute('href') || '').split('?')[0] : '';
          return href !== current;
        });
        cards = cards.slice(0, limit);
        if (!cards.length) { showEmpty(); return; }
        cards.forEach((c) => row.appendChild(c));
        stopLoading();
        row.hidden = false;
        axRailCarousel(row, ctrls);
      })
      .catch(() => { showEmpty(); });
  }

  document.querySelectorAll('[data-rail]').forEach(axInitRail);

  } catch(e) { console.error(e); }
})();
})();
